// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TranslationKey } from "./TranslationKey";
import {
  TranslationKeyFromJSON,
  TranslationKeyFromJSONTyped,
  TranslationKeyToJSON,
  TranslationKeyToJSONTyped,
} from "./TranslationKey";

/**
 *
 * @export
 * @interface TranslatableString
 */
export interface TranslatableString {
  /**
   *
   */
  type: TranslationKey;
  /**
   *
   */
  ctx?: { [key: string]: any } | null;
  /**
   * Return the message for the translation key, with context if available.
   */
  readonly msg: string;
}

/**
 * Check if a given object implements the TranslatableString interface.
 */
export function instanceOfTranslatableString(value: object): value is TranslatableString {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("msg" in value) || value["msg"] === undefined) return false;
  return true;
}

export function TranslatableStringFromJSON(json: any): TranslatableString {
  return TranslatableStringFromJSONTyped(json, false);
}

export function TranslatableStringFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TranslatableString {
  if (json == null) {
    return json;
  }
  return {
    type: TranslationKeyFromJSON(json["type"]),
    ctx: json["ctx"] === undefined ? undefined : json["ctx"] === null ? null : json["ctx"],
    msg: json["msg"],
  };
}

export function TranslatableStringToJSON(json: any): TranslatableString {
  return TranslatableStringToJSONTyped(json, false);
}

export function TranslatableStringToJSONTyped(
  value?: Omit<TranslatableString, "msg"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: TranslationKeyToJSON(value["type"]),
    ctx: value["ctx"],
  };
}
